










import { Vue, Component, Prop } from "vue-property-decorator";
import { TranslateResult } from "vue-i18n";
import { RawLocation } from "vue-router/types";

export interface ICrumb {
  label: string | TranslateResult;
  route?: {
    to: RawLocation;
  };
}

@Component
export default class UBreadcrumbs extends Vue {
  @Prop({ default: () => [] })
  private crumbs!: ICrumb[];
  // Computed
  private get mappedBreadcrumbs() {
    return this.$_.map(this.crumbs, crumb => ({
      ...this.$_.pick(crumb, ["label"]),
      is: crumb.route ? "u-link" : "span",
      attrs: crumb.route ? { ...crumb.route, tag: "router-link" } : null
    }));
  }
}
